import React, { useCallback, useEffect, useState } from 'react'
import classnames from 'classnames'
import styled from 'styled-components'
import Icon from '../Icon'

const Radiostyled = styled.label`
  display: flex;
  flex-wrap: wrap;
  .radio-item {
    display: flex;
    input {
      display: none;
    }
  }
  svg {
    color: #ffffff;
    font-size: 24px;
    margin-right: 12px;
  }
  &.disabled {
    cursor: not-allowed;
    svg {
      color: #474747;
    }
  }
`
interface Props {
  className?: string
  options: Array<{key: string | number, label: string | React.ReactNode}>
  defaultChecked?: Props['options'][number]['key']
  disabled?: boolean
  onChange: (value: Props['options'][number]['key']) => void
}
export default function Checkbox(props: Props) {
  const { options, defaultChecked = '', className, disabled, onChange, ...rest } = props
  const [checked, setChecked] = useState<Props['options'][number]['key']>(defaultChecked)

  useEffect(() => {
    if (disabled) {
      setChecked(defaultChecked)
    }
  }, [disabled, defaultChecked])

  const handleChange = useCallback((value) => {
    if (disabled) return
    setChecked(value)
    onChange?.(value)
  }, [disabled])

  return (
    <Radiostyled
      className={classnames({ disabled }, className)}
      {...rest}
    >
      {options.map(opt => (
        <div className="radio-item" key={opt.key} >
            <input type="radio" id={String(opt.key)} name={String(opt.key)} value={opt.key} />
            <Icon onClick={() => handleChange(opt.key)} type={checked === opt.key ? 'danxuangouxuan' : 'danxuankuang'} />
            <label onClick={() => handleChange(opt.key)} htmlFor={String(opt.key)}><>{opt.label}</></label>
        </div>
      ))}
    </Radiostyled>
  )
}
